module.exports = "https://www.gc-pro.gnp.com.mx/d8c27bb123bbc57720fb5854895159a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vector.svg
// module id = 8172
// module chunks = 0